import { render, staticRenderFns } from "./SidLinkedGroup.vue?vue&type=template&id=366555e6"
import script from "./SidLinkedGroup.vue?vue&type=script&lang=js"
export * from "./SidLinkedGroup.vue?vue&type=script&lang=js"
import style0 from "./SidLinkedGroup.vue?vue&type=style&index=0&id=366555e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports